import { categoryList } from "@/mocks/gossip";

export default function Categories() {
  return (
    <section
      id="category"
      className="scroll-mt-24 w-full bg-background-900 py-12 md:py-16"
    >
      <div className="mx-auto w-full max-w-[1320px] px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold tracking-wide text-accent-400">
              <i className="ri-grid-fill h-4 w-4 flex items-center justify-center" />
              COLUMNS · 栏目导航
            </p>
            <h2 className="mt-2 font-display text-2xl font-bold text-background-50 md:text-3xl">
              按兴趣开吃，不漏掉你关心的瓜
            </h2>
            <p className="mt-2 text-sm text-background-300">
              六大栏目持续更新，挑一个你最常蹲的点进去逛。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categoryList.map((c) => (
            <a
              key={c.name}
              href="#hot"
              className="group flex items-center gap-4 rounded-lg border border-background-800 bg-background-800/40 p-4 transition-all duration-300 hover:border-primary-500/60 hover:bg-background-800"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary-600/90 text-background-50 transition-colors group-hover:bg-primary-500">
                <i className={`${c.icon} h-6 w-6 flex items-center justify-center`} />
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center justify-between">
                  <span className="font-label text-base font-semibold text-background-50">
                    {c.name}
                  </span>
                  <span className="text-xs text-background-400">
                    {c.count} 条
                  </span>
                </span>
                <span className="mt-1 block truncate text-xs text-background-400">
                  {c.desc}
                </span>
              </span>
              <i className="ri-arrow-right-line h-5 w-5 flex items-center justify-center text-background-500 transition-all group-hover:translate-x-1 group-hover:text-accent-400" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}